import { render } from "./CreateForm.vue?vue&type=template&id=71a286b3&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"

import "./CreateForm.vue?vue&type=style&index=0&id=71a286b3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71a286b3"

export default script